export const bundle = {
  pkg: "@apollo/client-integration-tanstack-start",
  client: "ApolloClient",
  cache: "InMemoryCache",
};
